var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('google-map-loader',{attrs:{"mapConfig":_vm.mapConfig},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var google = ref.google;
var map = ref.map;
return [_c('google-map-marker',{ref:"floatMarker",attrs:{"marker":_vm.floatMarker,"google":google,"map":map,"floating":true,"nearestLocation":_vm.nearestLocation}}),_c('google-map-line',{attrs:{"path":_vm.line,"google":google,"map":map}}),_c('google-map-bounds',{attrs:{"path":_vm.line,"google":google,"map":map}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }